import { useState } from 'react';
import { ScoringType } from '../../Exams/types';
import { SubSkillResponse } from '../types';

export const TEMP_SUBSKILL_ID_PREFIX = 'temp-';

const useSubSkillEditor = (scoringTypes: ScoringType[]) => {
  const [editingSubSkillId, setEditingSubSkillId] = useState<string | null>(
    null
  );
  const [description, setDescription] = useState('');
  const [scoringTypeId, setScoringTypeId] = useState('');
  const [order, setOrder] = useState('');
  const [maxMarks, setMaxMarks] = useState('');

  const editingScoringType = scoringTypes.find((st) => st.id === scoringTypeId);
  const showMaxMarks =
    !!scoringTypeId &&
    (!editingScoringType?.validScores ||
      editingScoringType.validScores.length === 0);

  const reset = () => {
    setDescription('');
    setScoringTypeId('');
    setOrder('');
    setMaxMarks('');
    setEditingSubSkillId(null);
  };

  const openEdit = (subSkill: SubSkillResponse) => {
    const resolvedId =
      typeof subSkill.scoringType === 'string'
        ? subSkill.scoringType
        : subSkill.scoringType?.id || '';
    setDescription(subSkill.description);
    setScoringTypeId(resolvedId);
    setOrder(String(subSkill.order));
    setMaxMarks(subSkill.maxMarks != null ? String(subSkill.maxMarks) : '');
    setEditingSubSkillId(subSkill.id);
  };

  const handleScoringTypeChange = (value: string) => {
    setScoringTypeId(value);
    const st = scoringTypes.find((s) => s.id === value);
    const willShowMaxMarks =
      !!value && (!st?.validScores || st.validScores.length === 0);
    if (!willShowMaxMarks) setMaxMarks('');
  };

  const buildSubSkill = (): SubSkillResponse => {
    const scoringTypeObj = scoringTypes.find((st) => st.id === scoringTypeId);
    return {
      id: editingSubSkillId || `${TEMP_SUBSKILL_ID_PREFIX}${Date.now()}`,
      description,
      scoringType: scoringTypeObj
        ? {
            id: scoringTypeObj.id!,
            name: scoringTypeObj.name,
            validScores: scoringTypeObj.validScores || []
          }
        : scoringTypeId,
      order: Number(order) || 0,
      ...(maxMarks !== '' && { maxMarks: Number(maxMarks) })
    };
  };

  return {
    isEditing: !!editingSubSkillId,
    description,
    scoringTypeId,
    order,
    maxMarks,
    showMaxMarks,
    reset,
    openEdit,
    handleScoringTypeChange,
    buildSubSkill,
    setDescription,
    setOrder,
    setMaxMarks
  };
};

export default useSubSkillEditor;
